import { vlaLockApi } from "../../../api/client";
import { useApprovalStore } from "../../../stores/approvalStore";

/**
 * Releases the VLA In-Use (deal) lock if — and only if — the current user holds
 * it (`held-by-me`). Safe to call from any exit path (deal unmount, Exit,
 * Sign-out): it reads the shared lock state, so every trigger converges on one
 * idempotent release rather than each tracking its own "did I acquire?" flag.
 *
 * The store is flipped to a neutral state *before* the network call, so a
 * re-entrant or repeat call (e.g. Exit followed by ReviewPage unmount) bails on
 * the phase guard instead of firing a second DELETE. Release is best-effort — a
 * failed DELETE is swallowed and the backend reaper (spec FR-7) is the safety
 * net — and it never throws, so callers can `await` it before navigating away.
 * @returns {Promise<void>} Resolves once the release attempt settles.
 */
export async function releaseHeldVlaLock(): Promise<void> {
  const state = useApprovalStore.getState();
  const { approvalId } = state;
  if (state.lock.phase !== "held-by-me" || !approvalId) {
    return;
  }
  // Neutralize first so a concurrent/repeat call no-ops on the guard above.
  state.reset();
  try {
    await vlaLockApi.releaseLock(approvalId);
  } catch {
    // best-effort — the lock is reaped server-side if this fails
  }
}
